<template>
  <div>
    <Navbar />
    <SlideShow />
    <Project />
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/shared/Navbar.vue";
import SlideShow from "@/components/shared/SlideShow.vue";
import Project from "@/components/product/Product.vue";
import Footer from "@/components/shared/Footer.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    SlideShow,
    Project,
    Footer
  }
};
</script>
